import Link from "next/link";

import { useNavItems } from "@/base/Footer";
import PrivacyPreferencesButton from "@/datagrailIntegration/PrivacyPreferencesButton";
import ExperimentManager from "@/experimentManager/components/ExperimentManager";
import formatHrefToSupportLegacyLink from "@/utils/formatHrefToSupportLegacyLink";
import { DATAGRAIL_LOADER_URL } from "@/datagrailIntegration/config";
import { atagCss, itemCss, footerSection, listCss } from "./CEFooter.style";

function CEFooter() {
  const navItems = useNavItems();
  return (
    <footer css={footerSection}>
      <ul css={listCss}>
        {navItems.map((item) => {
          return (
            <li key={item.label} css={itemCss}>
              <Link
                href={formatHrefToSupportLegacyLink(item.path)}
                passHref
                legacyBehavior
              >
                <a css={atagCss}>{item.label}</a>
              </Link>
            </li>
          );
        })}

        {DATAGRAIL_LOADER_URL && (
          <li css={itemCss}>
            <PrivacyPreferencesButton />
          </li>
        )}

        <li css={itemCss}>
          <ExperimentManager />
        </li>
      </ul>
    </footer>
  );
}

export default CEFooter;
